module.exports = __webpack_public_path__ + "img/yael-avatar@3x.ace9c330.png";